interface MeetingLoadingStateProps {
  message?: string;
}

export const MeetingLoadingState = ({
  message = "Đang kết nối đến cuộc họp...",
}: MeetingLoadingStateProps) => {
  return (
    <div className="flex h-screen items-center justify-center bg-background p-4">
      <div className="text-center">
        <div className="mb-4 inline-block h-10 w-10 sm:h-12 sm:w-12 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
        <p className="text-sm sm:text-lg font-medium">{message}</p>
      </div>
    </div>
  );
};

